import PackingListTemplateDTO from "@/dto/template/PackingListTemplateDTO";
import { observable, makeObservable, actionBound } from "mobx";
import api from "@/services/api/setting/packingListTemplate";
import to from "@/utils/to";

export default class PackListPrintStore {
    constructor() {
        makeObservable(this, {
            packListTemplatesLoading: observable,
            packListTemplates: observable,
            load: actionBound,
            clear: actionBound,
        });
    }

    packListTemplatesLoading = false;

    packListTemplates: PackingListTemplateDTO[] = [];

    async load() {
        this.packListTemplatesLoading = true;

        const [, result] = await to(api.getTemplates());

        this.packListTemplatesLoading = false;

        if (result) {
            this.packListTemplates = result;
        }

        return this.packListTemplates;
    }

    clear() {
        this.packListTemplates = [];
    }
}
